import { useParams } from 'react-router';
import { useClientFetch } from '../../../context/ClientStatusContext';
import { ClientStatus } from '../../../model/ClientStatus';
import { fetchPripomienkaDetail } from '../../../client/pripomienkaDetailClient';
import PripomienkaDetail from '../../../model/pripomienka/PripomienkaDetail';
import ClassType, { classTypeToGenerated } from '../../../model/pripomienka/ClassType';

interface ReturnType {
  pripomienkaDetail: PripomienkaDetail;
  pripomienkaStatus: ClientStatus;

  reloadPripomienkaDetail(): void;
}

interface Props {
  classType: ClassType;
}

export default ({ classType }: Props): ReturnType => {
  const {
    type,
    year,
    index,
    uuid,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, uuid: string }>();
  const {
    data: pripomienkaDetail,
    status: pripomienkaStatus,
    refetch: reloadPripomienkaDetail,
  } = useClientFetch(
    fetchPripomienkaDetail,
    [classTypeToGenerated(classType), type, year, index, uuid],
    [uuid],
  );
  return {
    pripomienkaDetail,
    pripomienkaStatus,
    reloadPripomienkaDetail,
  };
};
